import { render, staticRenderFns } from "./my-center.vue?vue&type=template&id=0eaf8284"
import script from "./my-center.vue?vue&type=script&lang=js"
export * from "./my-center.vue?vue&type=script&lang=js"
import style0 from "./my-center.vue?vue&type=style&index=0&id=0eaf8284&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports